import { render, staticRenderFns } from "./TheHomeIcon.vue?vue&type=template&id=7bbcda90&"
import script from "./TheHomeIcon.vue?vue&type=script&lang=js&"
export * from "./TheHomeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports